import React from 'react'
import PropTypes from 'prop-types'
import TitleBar from '../Layout/titleBar'
import { Row, Col } from 'react-flexbox-grid'
import Pagination from '../Layout/pagination';
import Paper from '@material-ui/core/Paper';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state/index';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';

import DialogContent from '@material-ui/core/DialogContent';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CloseIcon from '@material-ui/icons/Close';

import Dialog from '@material-ui/core/Dialog';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';

import {
    ToggleOffOutlined as ToggleOffOutlinedIcon
} from '@material-ui/icons';

import {
    PersonOffOutlined as PersonOffOutlinedIcon,
    PersonOutlineOutlined as PersonOutlineOutlinedIcon
} from '@mui/icons-material';

import Tooltip from '@material-ui/core/Tooltip'


const ItemUsuario = (props)=>{
    /**
     * nombre : titulo del item
     * descripcion: sub titulo, una linea
     * fecha: seguna linea de sub titulo, timestamp
     * monto: cantidad a la derecha, formateada como moneda
     * opciones: lista de opciones desplegables {nombre: string, handler: func}
     * onClick: click en cualquier lugar del item
     */
        return <div onClick={props.onClick} className='containerItemUsuario'>

                <div style={{display: 'flex'}}>
                    {(props.imagen !== undefined) && 
                    <img alt="" src={props.imagen} className='imgUsuario'/> }
                    
                    <div className='containerDatos'>
                        {<div className='labelNombre' style={{
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                whiteSpace: 'wrap',
                                wordBreak: 'break-all',
                                maxWidth: '300px',
                        }}>{props.nombre}</div>}
                        <div className='labelDescripcion'>{props.descripcion}</div>
                        {(props.descripcion2 !== undefined) && <div className='labelDescripcion'>{props.descripcion2}</div>}
                        {(props.descripcion3 !== undefined) && <div className='labelDescripcion' style={{
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                maxWidth: '300px',
                        }}>{props.descripcion3}</div>}
                    </div>
                    {(props.opciones !== undefined) && 
                    <div onClick={(e)=>{e.stopPropagation()}} className='iconMenu'>
                        <Col>
                        <Row style={{marginLeft:(props.activo === false && props.listaNegra === true && props.listaBlanca === true)?'-25px': // F T T (3 iconos)
                                                (
                                                    (props.activo === false && props.listaNegra === false && (props.listaBlanca === true)) || // F F T (2 iconos)
                                                    (props.activo === false && (props.listaNegra === true) && props.listaBlanca === false) || //F T F (2 iconos)
                                                    (props.activo === true && props.listaNegra === true && props.listaBlanca === true) //T F F (2 iconos)
                                                )?'-10px':
                                                (
                                                    props.activo === true && props.listaNegra === true && props.listaBlanca === true
                                                )?'0px':'5px'}} > {/*Sin iconos o con 1 icono*/}

                                            
                        { (props.activo !== true ) && <Col className='iconContainer'><Tooltip title="Usuario inactivo" placement="top"><ToggleOffOutlinedIcon style={{marginRight:'5px'}} className='icon_inactive'/></Tooltip></Col> }
                        { (props.listaNegra === true ) && <Col style={{marginRight:'5px'}} className='iconContainer'><Tooltip title="Usuario en lista negra" placement="top"><PersonOffOutlinedIcon className='icon_BlackList'/></Tooltip></Col> }
                        { (props.listaBlanca === true ) && <Col className='iconContainer'><Tooltip title="Usuario en lista blanca" placement="top"><PersonOutlineOutlinedIcon className='icon_WhiteList'/></Tooltip></Col> }
                        </Row>
                        <PopupState variant="popover" popupId={"nuevo-usuario-menu"}>
                            {popupState => (
                                <React.Fragment>
                                    <IconButton {...bindTrigger(popupState)}>
                                        <MoreVertIcon />
                                    </IconButton>
                                <Menu {...bindMenu(popupState)}>
                                    {
                                        props.opciones.map((x)=>{return x!==undefined ? <MenuItem onClick={(...args)=>{x.handler(...args);popupState.close(...args)}}>{x.nombre}</MenuItem> : undefined})
                                    }
                                </Menu>
                                </React.Fragment>
                            )}
                        </PopupState>
                        </Col>
                    </div>}
                </div>
                {(props.habilitado !== true ) && <div className='labelEstado'>{"Inhabilitado"}</div>}
                {/*{(props.activo !== true) && <div className='labelEstado'>{"Inactivo"}</div>}*/}
            
            </div>
    }

const styles = theme => ({
    papper: {
        minWidth: '300px',
    },
    rootDialog:{
        zIndex: 1505,
    },
    rootContent:{
        background: '#FFFFFF 0% 0% no-repeat padding-box',
        boxShadow: '-5px 4px 10px #8E8E8E29',
        borderRadius: '21px',
        opacity: 1,
        maxWidth: '850px',
        minWidth: '290px',
        padding: '0px !important',
        overflow: 'hidden',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
})

class UsuarioListado extends React.Component {

    render() {

        const { classes } = this.props;

        return (
            <div>

                {/* menú superior */}
                <TitleBar 
                    title='Usuarios'
                    searchPlaceholder='Ingrese usuario'
                    newButtonLink='/Usuarios/Edit/0'
                    showSearch = {true}
                    handleOnSearch={this.props.handleOnSearch} 
                    handleOnSearchAdvanced={this.props.handleOnAvanzado}
                />
                

                <Paper style={{backgroundColor:"transparent", boxShadow: 'none'}}>
                <div >
                    <Row>
                        {this.props.usuarios.result && this.props.usuarios.result.map((x,i)=>
                        <Col sm={12} md={6} lg={4} style={{margin: '5px 0px'}}>
                            <ItemUsuario {...this.props.mapToItem(x)}/>
                        </Col>)}
                    </Row>
                </div>
                <Pagination handleOnChange={this.props.handleOnPagination} page={this.props.usuarios.currentPage + 1 || 0} totalPages={this.props.usuarios.totalObjects !== 0 ? this.props.usuarios.totalPages : 0}/>
                </Paper>

                {/** confirmacion */}
                <Dialog 
                    classes={{root: classes.rootDialog, paperScrollPaper: classes.rootContent}}
                    id="ecommerce"
                    disableBackdropClick={true}
                    fullWidth={true}
                    maxWidth={'sm'}
                    open={this.props.openModalConfirm}
                    onClose={this.props.handleOnCloseConfirmacion}>
                    <div className='containerModalConfirmacion'>
                        <div className='labelModalConfirmacion'>{this.props.mensajeConfirmacion}</div>
                            <div className='containerBtnConfirmacion'>
                            <Button style={{marginRight:"12px"}} className="btnSecundario" onClick={this.props.handleOnCloseConfirmacion} >Cancelar</Button>
                            {
                                (this.props.botonOk.map)?
                                this.props.botonOk.map((x,i)=>
                                <Button style={{marginRight:"12px"}} variant="contained" className="btnPrincipalAux btnPrincipal" onClick={()=>{this.props.handleOk[i](); this.props.handleOnCloseConfirmacion(); window.setTimeout(()=>{this.props.handleOnPagination(this.props.usuarios.currentPage + 1 || 0);},700)}}>{this.props.botonOk[i]}</Button>
                                )
                                :<Button variant="contained" className="btnPrincipalAux btnPrincipal" onClick={()=>{this.props.handleOk(); this.props.handleOnCloseConfirmacion(); window.setTimeout(()=>{this.props.handleOnPagination(this.props.usuarios.currentPage + 1 || 0);},700)}}>{this.props.botonOk}</Button>
                            }
                        </div>
                    </div>
                </Dialog>

                {/**Filtros adicionales */}
                <Dialog 
                    id="ecommerce"
                    disableBackdropClick={true}
                    fullWidth={true}
                    maxWidth={'sm'}
                    open={this.props.openModal}
                    onClose={this.props.handleOnCloseModal}
                    classes={{paperWidthSm: classes.papper}}
                >
                    <h2 style={{fontWeight:"normal", margin:"14px", padding:"5px", borderBottom:"1px solid #9B9B9B"}}>Búsqueda avanzada</h2>
                    <div style={{width:"100%", padding:"12px"}}>
                    <Grid container spacing={24}>

                    <Grid item xs={12} sm={6}>
                    <TextField  fullWidth 
                    select
                    value={ this.props.tipoUsuario || undefined }
                    onChange={this.props.handleOnChangeFiltro}
                    input={<Input name="tipoUsuario" id="tipodeusuario-label" />}
                    InputLabelProps={
                        {shrink: this.props.tipoUsuario !== null}
                    }
                    displayEmpty
                    label="Tipo de Usuario"
                    name="tipoUsuario">
                    {(this.props.tiposUsuario && this.props.tiposUsuario.map)?
                        this.props.tiposUsuario.map((x)=>(<MenuItem value={x.id}>{x.name}</MenuItem>))
                        :undefined}</TextField>
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                    <TextField  fullWidth label={"Usuario"} onChange={this.props.handleOnChangeFiltro} name="nombre" value={ this.props.nombre} id="usuario-label" />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                    <InputLabel shrink htmlFor="tipodeusuario-label">Estado</InputLabel>
                    <TextField  fullWidth 
                    select
                    value={ this.props.estado }
                    onChange={this.props.handleOnChangeFiltro}
                    input={<Input name="estado" id="tipodeusuario-label" />}
                    InputLabelProps={
                        {shrink: this.props.estado !== null}
                    }
                    displayEmpty
                    name="estado">
                    {(this.props.estados && this.props.estados.map)?
                        this.props.estados.map((x)=>(<MenuItem value={x.id}>{x.name}</MenuItem>))
                        :undefined}</TextField>
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                    <TextField  fullWidth label={"Nombre Apellido"} onChange={this.props.handleOnChangeFiltro} name="nombre_apellido" value={ this.props.nombre_apellido} id="usuario-label" />
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                    <TextField  fullWidth label={"Razon Social"} onChange={this.props.handleOnChangeFiltro} name="razon_social" value={ this.props.razon_social} id="usuario-label" />
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                    <TextField label={"Localidad"} onChange={this.props.handleOnChangeFiltro} name="localidad" value={this.props.localidad} id="usuario-label" />
                    <Select style={{top:"16px"}} 
                    onChange={this.props.handleOnChangeFiltro}
                    onClose={this.props.localidadClose}
                    onOpen={this.props.localidadOpen}
                    open={this.props.localidadSuggest}
                    inputProps={{  name: 'localidad-select', id:"localidad-select"}}>
                        {this.props.localidades.map((x)=>(<MenuItem value={x}>{x}</MenuItem>))}
                    </Select>
                    </Grid>
                    
                    <Grid item xs={2}>
                    <Checkbox   style={{width:"90%"}} onChange={this.props.handleOnChangeFiltro} name="noHabilitados" checked={this.props.noHabilitados} id="usuario-label" />
                    </Grid>

                    <Grid item xs={10}>
                    <InputLabel style={{top:"12px", position:"relative"}} shrink htmlFor="usuario-label">Usuarios inhabilitados</InputLabel>
                    </Grid>
                    
                    <Grid item xs={2}>
                    <Checkbox   style={{width:"90%"}} onChange={this.props.handleOnChangeFiltro} name="noConfirmados" checked={this.props.noConfirmados} id="usuario-label" />
                    </Grid>
                    
                    <Grid item xs={10}>
                    <InputLabel style={{top:"12px", position:"relative"}} shrink htmlFor="usuario-label">Correos no confirmados</InputLabel>
                    </Grid>
                    
                    
                    </Grid >
                    
                        <div style={{textAlign:"center", marginTop:"44px"}}>
                            <Button style={{marginRight:"12px"}} className="btnSecundario" onClick={this.props.handleOnCloseAvanzado} >Cancelar</Button>
                            <Button variant="contained" className="btnPrincipal" onClick={()=>{this.props.handleOnSearch(this.props.nombre)}}>Buscar</Button>
                        </div>
                    </div>
                </Dialog>
                

                {/* MODAL CONFIRMACION DE PEDIDO */}
                <Dialog
                    classes={{root: classes.rootDialog, paperScrollPaper: classes.rootContent}}
                    open={this.props.openModalNotificaciones}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth='sm'
                    fullWidth={true}
                >
                    <DialogContent classes={{root: classes.rootContent}}>
                        <Row style={{margin: '0px'}}>

                            <Col  xs={12} md={12} lg={12}  style={{padding: '0px'}}>
                                <div className='containerModalNotificaciones'>

                                    <div className='containerTitle'>
                                        <div className='labelNotificaciones'>
                                            Notificaciones
                                        </div>
                                        <div style={{display: 'flex'}}>
                                            <CloseIcon cursor='pointer' fontSize='medium' onClick={() => {this.props.handleOnClickNotificaciones(undefined)}}/>
                                        </div>
                                    </div>
                                    
                                    {this.props.notificaciones && <div id='expandedNoti' className='containerNotificaciones'>
                                        {this.props.notificaciones.length > 0 && this.props.notificaciones.map((n) => {
                                            return <div style={{width: '100%'}}>
                                                        <ExpansionPanel>
                                                            <ExpansionPanelSummary
                                                                className='panelNoti'
                                                                expandIcon={<ExpandMoreIcon style={{color: '#FFFFFF'}} />}
                                                                aria-controls={`panel${n.idNotificacion}a-content`}
                                                                id={`panel${n.idNotificacion}a-header`}
                                                                >
                                                                <div>
                                                                    <div className='containerFechaInfo'>{n.fechaRegistro}</div>
                                                                    <Typography className={`${classes.heading} labelNoti`}>{n.nota.slice(0,30)}...</Typography>
                                                                </div>
                                                            </ExpansionPanelSummary>
                                                            <ExpansionPanelDetails style={{padding: '0px'}}>
                                                                <div className='labelNotiCompleta'>
                                                                    {n.nota}
                                                                </div>
                                                            </ExpansionPanelDetails>
                                                        </ExpansionPanel>
                                                    </div>
                                        })}
                                    </div>}

                                    {this.props.notificaciones && this.props.notificaciones.length === 0 &&
                                        <div className='labelNoNotificaciones'>No se encontraron categorías para mostrar</div>
                                    }
                                </div>
                            </Col>
                        </Row>
                    </DialogContent>
                </Dialog>
            </div>
        )
    }
}

UsuarioListado.propTypes = {
    usuarios: PropTypes.object.isRequired,
    tiposUsuario: PropTypes.array,
    handleOnChangeFiltro: PropTypes.func,
    handleOnChange: PropTypes.func.isRequired,
    handleOnSave: PropTypes.func.isRequired,   
    handleOnSearch : PropTypes.func.isRequired,
    handleOnCloseConfirmacion: PropTypes.func,
    openModalNotificaciones: PropTypes.bool.isRequired,
    notificaciones: PropTypes.object,
    handleOnClickNotificaciones: PropTypes.func,
}

UsuarioListado.defaultProps = {
    catalogos: []
}

export default  withStyles(styles)(UsuarioListado)